// extracted by mini-css-extract-plugin
export default {"root":"root--SAJ-F","slim":"slim--SAJ-F","medium":"medium--SAJ-F","large":"large--SAJ-F","xlarge":"xlarge--SAJ-F","center":"center--SAJ-F","right":"right--SAJ-F"};